export const SAVE_PROCESSING_COST = 'processingCost/SAVE_PROCESSING_COST'
export const FETCH_PROCESSING_COSTS = 'processingCost/FETCH_PROCESSING_COSTS'
export const CHANGE_CURRENT_PAGE = 'processingCost/CHANGE_CURRENT_PAGE'
export const CHANGE_DATES_RANGE = 'processingCost/CHANGE_DATES_RANGE'
export const REMOVE_PROCESSING_COST = 'processingCost/REMOVE_PROCESSING_COST'